export interface CloseConsultancyModalProps {
    open: boolean;
    onClose: () => void;
    onConsultancyClosed?: (consultancyId: number) => void;
    consultancyId?: number;
    paymentId: number;
    pinner_first_name: string;
}

export interface ConsultancyProps {
    id: number;
    purchased_at: string;
    status: ConsultancyStatus;
    amount?: number;
    user: {
        id: number;
        profile_picture: string;
        first_name: string;
        last_name: string;
        email: string;
    };
    pinnerpro_consultancy: {
        type: Plan;
    };
}

export enum Plan {
    FREE = 0,
    LIGHT = 1,
    PLUS = 2
}

export enum ConsultancyStatus {
    PENDING = 0,
    COMPLETED = 1,
    REJECTED = 2
}